import { CustomerResponseDataSchema } from "schema"
import { z } from "zod"

export const BackofficeGetCustomerResponseDataSchema = CustomerResponseDataSchema.extend(
  z.object({
    companyId: z.bigint().transform(String),
  }).shape,
)

export const BackofficeGetCustomersResponseDataSchema = z.array(
  BackofficeGetCustomerResponseDataSchema,
)
